// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectSpecialAssumptionQueryResult, selectSpecialAssumptionsPageLoading, selectSpecialAssumptionsShowInitWaitingMessage} from '../_selectors/special-assumption.selectors';

export class SpecialAssumptionsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectSpecialAssumptionsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectSpecialAssumptionsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectSpecialAssumptionQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
